/* unplugin-vue-components disabled */import script from "./AccountAsset.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountAsset.vue?vue&type=script&setup=true&lang=js"

import "./AccountAsset.vue?vue&type=style&index=0&id=00b7ed48&lang=scss"

const __exports__ = script;

export default __exports__